import * as $ from 'jquery';

export class Loader {
    private static template =
        `<div class="blocker  blocker--inline">
            <div class="blocker__loader"></div>
        </div>`;

    static create(): JQuery {
        return $(this.template);
    }
}